import Newsfeed from "./newsfeed/newsfeed";
import React from "react";
import { Container, Grid } from "@mui/material";
import ProfileContainer from "./sidebar/profile";
import TasksContainer from "./sidebar/tasks";
import LeaveBalance from "./sidebar/leave-balance";
import Attendance from "./sidebar/attendance";
import QuickLinks from "./sidebar/quickLinks";
import "./home.scss";

const Dashboard = () => {
  return (
    <Container maxWidth="xl">
      <Grid container>
   
          <Grid item xs={12} lg={3} xl={3}>
            <ProfileContainer />
            <TasksContainer />
            <LeaveBalance />
            <Attendance />
            <QuickLinks />
          </Grid>
          <Grid
          sx={{ background: "#fff", padding: { sm: "0px", md: "30px" } }}
          item
          xs={12}
          md={6}
        >
          <Newsfeed />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;
